/* Northern Raised homepage kit JS.
   Conventions: IIFE, data-attribute scoped, nrInit guards,
   init on DOMContentLoaded + shopify:section:load, reduced motion respected. */
(function () {
  "use strict";
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function reduced() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }

  /* ---------- Scroll reveals ---------- */
  var revealIO = null;
  function initReveals(root) {
    var els = $$(".nr-reveal", root);
    if (root.classList && root.classList.contains("nr-reveal")) els.push(root);
    if (!("IntersectionObserver" in window) || reduced()) {
      els.forEach(function (el) { el.classList.add("nr-in"); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("nr-in"); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.14 });
    }
    els.forEach(function (el) {
      if (el.dataset.nrRevealInit) return;
      el.dataset.nrRevealInit = "1";
      revealIO.observe(el);
    });
  }

  /* ---------- Marquee ticker ---------- */
  function initTicker(root) {
    $$("[data-nr-ticker]", root).forEach(function (track) {
      if (track.dataset.nrInit) return;
      track.dataset.nrInit = "1";
      track.innerHTML += track.innerHTML;
      var speed = parseInt(track.dataset.speed, 10);
      if (speed > 0) track.style.animationDuration = speed + "s";
    });
  }

  /* ---------- Weekly cutoff countdown (America/Toronto) ---------- */
  function torontoNow() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Toronto" }));
  }
  function initCutoff(root) {
    $$("[data-nr-cutoff]", root).forEach(function (el) {
      if (el.dataset.nrInit) return;
      el.dataset.nrInit = "1";
      var mode = el.dataset.cutoffMode || "daily";
      var day = parseInt(el.dataset.cutoffDay, 10);
      var parts = (el.dataset.cutoffTime || "23:59").split(":");
      var hh = parseInt(parts[0], 10) || 23, mm = parseInt(parts[1], 10) || 59;
      if (isNaN(day)) day = 0;
      function tick() {
        var now = torontoNow();
        var target = new Date(now);
        target.setHours(hh, mm, 0, 0);
        if (mode === "daily") {
          if (target <= now) target.setDate(target.getDate() + 1);
        } else {
          var delta = (day - now.getDay() + 7) % 7;
          target.setDate(target.getDate() + delta);
          if (target <= now) target.setDate(target.getDate() + 7);
        }
        var ms = target - now;
        var d = Math.floor(ms / 864e5);
        var h = Math.floor(ms % 864e5 / 36e5);
        var m = Math.floor(ms % 36e5 / 6e4);
        el.textContent = d > 0 ? d + "d " + h + "h" : h + "h " + m + "m";
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  /* ---------- Carousel arrows ---------- */
  function initCaro(root) {
    $$("[data-nr-caro]", root).forEach(function (c) {
      if (c.dataset.nrInit) return;
      c.dataset.nrInit = "1";
      var track = $("[data-nr-caro-track]", c);
      if (!track) return;
      $$("[data-nr-caro-btn]", c).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 20 : 300;
          var dir = btn.dataset.nrCaroBtn === "next" ? 1 : -1;
          track.scrollBy({ left: dir * step * 2, behavior: reduced() ? "auto" : "smooth" });
        });
      });
    });
  }

  /* ---------- Hero parallax ---------- */
  function initParallax(root) {
    $$("[data-nr-parallax]", root).forEach(function (bg) {
      if (bg.dataset.nrInit) return;
      bg.dataset.nrInit = "1";
      if (reduced()) return;
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || 0;
          bg.style.transform = "translateY(" + Math.min(y * 0.16, 160) + "px)";
          ticking = false;
        });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    });
  }

  /* ---------- Quick add to cart (Dawn architecture drawer rendering) ---------- */
  function initQuickAdd() {
    if (document.body.dataset.nrHomeCart) return;
    document.body.dataset.nrHomeCart = "1";
    document.addEventListener("click", function (ev) {
      var btn = ev.target.closest("[data-nr-add]");
      if (!btn || btn.disabled) return;
      ev.preventDefault();
      var id = parseInt(btn.dataset.variantId, 10);
      if (!id) return;
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.addingText || "Adding...";
      var drawer = document.querySelector("cart-drawer");
      var notif = document.querySelector("cart-notification");
      var sections = [];
      if (drawer) sections = ["cart-drawer", "cart-icon-bubble"];
      else if (notif) sections = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1 }],
          sections: sections.join(","),
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      }).then(function (data) {
        try {
          if (drawer && typeof drawer.renderContents === "function") {
            drawer.classList.remove("is-empty");
            drawer.renderContents(data);
          } else if (notif && typeof notif.renderContents === "function") {
            notif.renderContents(data);
          } else {
            fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
              $$(".cart-count-bubble span[aria-hidden], [data-cart-count]").forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
          }
        } catch (e) { /* cart updated server side regardless */ }
        btn.textContent = btn.dataset.addedText || "Added";
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
      }).catch(function () {
        btn.textContent = "Try again";
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
      });
    });
  }

  /* ---------- Live Loox reviews (Storefront API, same pattern as the PDP kit) ---------- */
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }
  function starRow(v) {
    var out = "";
    for (var i = 0; i < 5; i++) {
      out += '<svg style="opacity:' + (i < v ? "1" : ".25") + '"><use href="#nr-i-star"/></svg>';
    }
    return '<span class="nr-stars">' + out + "</span>";
  }
  function initLoox(root) {
    $$("[data-nr-loox-api]", root).forEach(function (el) {
      if (el.dataset.nrInit) return;
      el.dataset.nrInit = "1";
      var store = el.dataset.storeId, pid = el.dataset.productId;
      var section = el.closest(".nr-home-reviews") || document;
      var status = $("[data-nr-loox-status]", section);
      var grid = $("[data-nr-loox-cards]", section);
      if (!store || !pid || !grid) return;
      var url = "https://storefront-api.loox.io/storefront/v1/store/" + encodeURIComponent(store) + "/product-reviews?product_id=" + encodeURIComponent(pid);
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      }).then(function (data) {
        var list = data.reviews || data.data || data.items || (Array.isArray(data) ? data : []);
        if (!Array.isArray(list) || !list.length) {
          if (status) status.textContent = "No reviews returned from Loox yet.";
          return;
        }
        var sum = 0, hist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, rated = 0;
        list.forEach(function (r) {
          var v = parseInt(r.rating || r.stars, 10);
          if (v >= 1 && v <= 5) { sum += v; hist[v]++; rated++; }
        });
        if (rated) {
          var avg = (sum / rated).toFixed(1);
          var scoreEl = $("[data-nr-agg-score]", section);
          var countEl = $("[data-nr-agg-count]", section);
          if (scoreEl) scoreEl.textContent = avg;
          if (countEl) countEl.textContent = "Based on " + rated + " verified reviews";
          for (var s = 1; s <= 5; s++) {
            var pct = Math.round(hist[s] / rated * 100);
            var fill = $('[data-nr-bar="' + s + '"] .nr-rev-bar-fill', section);
            var lab = $('[data-nr-bar-label="' + s + '"]', section);
            if (fill) fill.style.setProperty("--w", pct + "%");
            if (lab) lab.textContent = pct + "%";
          }
        }
        grid.innerHTML = list.slice(0, 8).map(function (r) {
          var v = Math.min(5, Math.max(1, parseInt(r.rating || r.stars, 10) || 5));
          var name = r.name || r.reviewer_name || r.author || "Verified buyer";
          var text = r.text || r.body || r.content || "";
          return '<div class="nr-rev-card">' + starRow(v) +
            "<p>" + esc(text) + "</p>" +
            '<div class="nr-rev-who"><b>' + esc(name) + '</b><span class="nr-rev-verified"><svg width="13" height="13" viewBox="0 0 20 20"><use href="#nr-i-check"/></svg>Verified</span></div></div>';
        }).join("");
        if (status) status.textContent = "";
      }).catch(function () {
        if (status) status.textContent = "Live reviews could not be loaded. Showing nothing rather than something stale.";
      });
    });
  }

  function initAll(root) {
    initReveals(root);
    initTicker(root);
    initCutoff(root);
    initCaro(root);
    initParallax(root);
    initQuickAdd();
    initLoox(root);
  }
  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
